import GlobalForm from "../../components/globalForm/GlobalForm";
import Loading from "../../components/shared/loading/Loading";
import { updateData } from "../../hooks/update";
import useFetch from "../../hooks/useFetch";
import { apiPath } from "../../utility/Constant";


const PackageContentPage = () => {
  const { packageApi } = apiPath;
  const [homePackage, packageLoading] = useFetch(packageApi);
  if (packageLoading) {
    return <Loading />;
  }
  // console.log(homePackage)
  // const packagePageContent = homePackage.data.find(item => item.slug === "banner")
  const { _id, bannerImg, bannerTitle, bannerDescription } = homePackage;

  const packageContentApi = `package/${_id}`;

  const data = [
    {
      elementType: "file",
      label: "Banner Image",
      type: "Text",
      name: "bannerImg",
      defaultValue: bannerImg,
      required: true,
    },
    {
      elementType: "input",
      label: "Banner Title",
      type: "Text",
      name: "bannerTitle",
      defaultValue: bannerTitle,
      required: true,
    },
    // {
    //   elementType: "input",
    //   label: "Banner Description",
    //   type: "Text",
    //   name: "bannerDescription",
    //     defaultValue: bannerDescription,
    //   required: true,
    // },
  ];

  const update = (data) => {
    updateData(packageContentApi, data, true);
  };

  return (
    <div>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default PackageContentPage;